/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import { modernViewerDropinContext, contextMenuPlacements, VERB_COPY_TEXT } from "constants/enums";
import copyIcon from "dc-icons/viewer2021/SDC_Copy_18_N.svg";
import copyIconMobile from "dc-icons/viewer2021/Web_Mobile/SDC_Copy_22_N.svg";
import { pageContentHandler } from "../pageContentHandler";
import { trackCopyTextFromContextMenu } from "../analytics/events";
import * as stores from "stores";

class CopyTextBootstrap extends Component {
  getLabel = () => getMessage("contextMenu.modernViewer.copyText");

  getIcon = opts =>
    opts && opts.context === modernViewerDropinContext.MODERN_MOBILE_CONTEXT_MENU ? copyIconMobile : copyIcon;

  getTooltip = () => getMessage("contextMenu.modernViewer.copyText");

  getAriaLabel = () => getMessage("contextMenu.modernViewer.copyText");

  getPlacement = () => contextMenuPlacements.CONTEXT_MENU_BODY;

  id = VERB_COPY_TEXT;

  initializeAction = () => {};

  executeAction = (opts = {}) => {
    const allowedCopyTextContext = [
      modernViewerDropinContext.CONTEXT_MENU,
      modernViewerDropinContext.MODERN_MOBILE_CONTEXT_MENU
    ];
    if (opts.context && allowedCopyTextContext.includes(opts.context)) {
      const textManager = pageContentHandler.getTextManagerInstance();
      textManager.copyText();
      textManager.clearSelection(stores);
      trackCopyTextFromContextMenu();
    }
  };

  render() {
    return null;
  }
}

export default CopyTextBootstrap;
